import React, { useEffect, useState } from 'react';
import { Route, Routes, NavLink } from 'react-router-dom';
import { motion } from "framer-motion";
import { getCookie, setCookie } from './utils/cookies';
import { Footer, Navbar, Header } from './Component';
import { Terms,Register, Login, Processing, Technology, Tutorials, Challenge, Submission, Web, MyProfil, Admin, Applications, AdminSubbmissions, AdminOrders, ImagePresenter  } from './Pages';
import './App.css'
import back from "./assets/back.jpeg"

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Process Tutorials', href: '/Process_Tutorials' },
  { name: 'Image Processing', href: '/Processing' },
  { name: 'Web Shop', href: '/Web_Shop' },
  { name: 'QAE', href: '/AdminSubbmissions' },
  { name: 'Terms of use', href: '/Terms' }
];

const App = () => {

  const [sticky, setSticky] = useState(false);
  const [wid, setWid] = useState(true);
  const [vara, setVara] = useState(true);
  const [signedIn, setSignedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const [orders, setOrders] = useState([])

  const min = 1;
  const max = 10;
  const rand = min + Math.random() * (max - min);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  useEffect(() => {
    const _name = getCookie('_name');
    const _email = getCookie('_email');
    if (_name !== " " && _name !== undefined && _name !== null) {
      setUserName(_name)
      setUserEmail(_email)
      setSignedIn(true)
    }
  })

  setTimeout(() => {
    setVara(false);
  }, 6000)

  const signIn = (name, email) => {
    setUserName(name);
    setUserEmail(email);
    setSignedIn(true);
  }

  const signOut = () => {
    setUserName("");
    setUserEmail("");
    setSignedIn(false);
  }

  const addOrder = (newOrder) => {
    const updatedOrders = [...orders, newOrder];
    setOrders(updatedOrders);
  }


  return (
    <>
      <div className='App'>
        {wid && (
          <>
            <div className='App-second'>
              <div className='Up'>
                <nav className={`${sticky ? 'sticky' : ''}`}>
                  <Navbar orders={orders} widChanger={setWid} signedIn={signedIn} userName={userName} userEmail={userEmail} signOut={signOut} />
                </nav>

                <div className='Page'>

                  <Routes>
                    <Route path='/' element={<Header prop={vara} userEmail={userEmail} />} />
                    <Route path='/Register' element={<Register signIn={signIn} />} />
                    <Route path='/Register/:id' element={<Register signIn={signIn} />} />
                    <Route path='/Login' element={<Login signIn={signIn} />} />
                    <Route path='/Processing' element={<Processing userEmail={userEmail} />} />
                    <Route path='/Intrinsic_Technology' element={<Technology />} />
                    <Route path='/Process_Tutorials' element={<Tutorials />} />
                    <Route path='/Intrinsic_Challenge' element={<Challenge />} />
                    <Route path='/Image_Submission' element={<Submission userEmail={userEmail} />} />
                    <Route path='/Web_Shop' element={<Web/>} />
                    <Route path='/My_Profile' element={<MyProfil />} />
                    <Route path='/Admin' element={<Admin />} />
                    <Route path='/AdminSubbmissions' element={<AdminSubbmissions />} />
                    <Route path='/AdminOrders' element={<AdminOrders />} />
                    <Route path='/Applications' element={<Applications />} />
                    <Route path='/Terms' element={<Terms />} />
                    <Route path='/ImagePresenter' element={<ImagePresenter />} />
                    
                  </Routes>
                </div>

              </div>
            </div>
          </>
        )}
        {!wid && (
          <>
            <nav className={`${sticky ? 'sticky' : ''}`}>
              <Navbar widChanger={setWid} />
            </nav>
            <div className='fulNav' onClick={() => { setWid(true) }}>
              {
                navigation.map((item) => (
                  <div className='fulNav_div'>
                    <p>
                      <NavLink
                        key={item.name}
                        to={item.href}
                        className={({ isActive }) => {
                          return (
                            (!isActive
                              ? 'cqc__fulNavP2'
                              : 'cqc__fulNavP'
                            )
                          );
                        }}
                      >
                        {item.name}
                      </NavLink>
                    </p>
                  </div>
                ))
              }
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default App

